import { useSelector } from 'react-redux'
import { UserTypeEnum } from '../enums'

/**
 * Hook to get current user's role/type from Redux store
 * @returns {string|null} Current user type (admin, agent, student) or null if not authenticated
 */
const useUserRole = () => {
  const userInfo = useSelector((state) => state.auth?.userInfo || {})
  const userType = userInfo?.userType || null
  
  return userType
}

/**
 * Hook to check if current user has specific role(s)
 * @param {string|string[]} allowedRoles - Single role or array of roles to check
 * @returns {boolean} True if user has one of the allowed roles
 */
export const useHasRole = (allowedRoles) => {
  const userType = useUserRole()
  
  if (!userType || !allowedRoles) {
    return false
  }
  
  const rolesArray = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles]
  return rolesArray.includes(userType)
}

/**
 * Hook to check if current user is admin
 * @returns {boolean} True if user is admin
 */
export const useIsAdmin = () => {
  return useHasRole(UserTypeEnum.ADMIN)
}

/**
 * Hook to check if current user is agent
 * @returns {boolean} True if user is agent
 */
export const useIsAgent = () => {
  return useHasRole(UserTypeEnum.AGENT)
}

/**
 * Hook to check if current user is student
 * @returns {boolean} True if user is student
 */
export const useIsStudent = () => {
  return useHasRole(UserTypeEnum.STUDENT)
}

export default useUserRole

